import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useAlert } from 'react-alert'

import { GetApi } from '../../Common/ApiAxios'
import { SetLoadSpinner } from '../../Common/Slice/LoadSpinnerSlice'
import ErrorHandling from '../../Common/ErrorHandling'
import FUNC from '../../Common/FunctionEnum'
import { createAllocationInfo } from '../../Common/Utilties/ObjectUtitlity'

import MasterPanelWrap from '../Wrap/MasterPanelWrap'
import MasterFlexWrap from '../Wrap/MasterFlexWrap'
import MasterListView from '../Molcules/MasterListView'
import Search from './Search'
import AllocationDetail from './AllocationDetail'

import MasterSelect from '../MasterSelect'

export const DefaultUrl = '/api/masterManagement/allocation'

const Allocation = (props) => {
    const orderIdRef = useRef()
    const [dataList, setDataList] = useState([])
    const [detail, setDetail] = useState(null) // 未選択状態
    const [selectedId, setSelectedId] = useState(null)
    const [searchOption, setSearchOption] = useState({ orderId: '' })
    const { loginUserInfo } = useSelector(state => state)
    const [pagenation, setPagenation] = useState({})
    const dispatch = useDispatch()
    const alert = useAlert()
    const grants = loginUserInfo.menuList && loginUserInfo.menuList.find(menu => menu.functionMenuId === FUNC.ALLOCATION)

    const selectItem = async (id) => {
      dispatch(SetLoadSpinner(true))
      //setSelectedId(id)
      console.log(id)
      //var tokens = id.split('_');
      setSelectedId(id)
      //console.log(tokens[0])
      //console.log(tokens[1])
      //console.log(tokens[2])
      //const result = await GetApi(`${DefaultUrl}/${tokens[0]}/${tokens[1]}/${tokens[2]}`)
      const result = await GetApi(`${DefaultUrl}/${id}`)
      console.log(result)
      dispatch(SetLoadSpinner(false))
      ErrorHandling(result, alert) || setDetail(result.data)
    }

    // 新規登録用初期化処理
    const createNew = (e) => {
      setDetail(createAllocationInfo()) // 新規作成時の値
      setSelectedId(null)
    }

    // 検索APIの実行
    const onSearch = async (createId, page) => {
      dispatch(SetLoadSpinner(true))
      setSearchOption(
        {
          orderId: orderIdRef.current.value,
        }
      )
      const data = {
        orderId: grants.readGrantDivision === 3 ? loginUserInfo.orderId : orderIdRef.current.value,
        page: page
      }
      const result = await GetApi(DefaultUrl, data)
      dispatch(SetLoadSpinner(false))
      if (result.errorDetail) {
        ErrorHandling(result, alert)
        return null
      } else {
        const resultList = result.data.responseList.map(item => {
          return {
            //index: item.staffId + '_' + item.orderId + '_' + item.employmentStartDt,
            //id: item.orderId,
            id: item.staffId + '/' + item.orderId + '/' + item.employmentStartDt,
            name: item.staffName +'【' +item.employmentStartDt + '】',
            delFlag: false,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
          }
        })
        setDataList(resultList)
        setPagenation(result.data)
        const isSelected = resultList.find(item => item.id === (createId || selectedId))
        if (!isSelected) {
          setSelectedId(null)
          setDetail(null) // 未選択状態
        }
      }
    }
    const onKeyDown = (event) => {
      if (event.keyCode === 13) {
        onSearch(null, 1)
      }
    }

    const pageSelectFunc = (pageId) => {
      onSearch(null, pageId)
    }

    useEffect(() => {
      if (grants)
        document.title = grants.functionMenuName + ' | Core Time Cloud'
      else
        document.title = 'Core Time Cloud'
    }, [grants])

    //画面表示の時
    useEffect(()=>{
      onSearch(null,1)
    },[])
    
    if (!grants) return null
    return (
        <MasterPanelWrap id='AllocationWrap'>
        <Search
          title={grants.functionMenuName}
          showButton
          onClick={() => onSearch(null, 1)}
          onKeyDown={(e) => onKeyDown(e)}
          orderIdRef={orderIdRef}
          grants={grants}
        >
        </Search>
        <MasterFlexWrap>
          <MasterSelect/>
            <MasterListView
              dataList={dataList}
              setSelectedId={setSelectedId}
              selectFunction={(id) => selectItem(id)}
              createFunction={() => createNew()}
              canWrite={grants.writeGrantDivision === 2 || grants.writeGrantDivision === 1}
              pageSelectFunc={pageSelectFunc}
              pagenation={pagenation}
              isIdView={false}
            />
            <AllocationDetail
              onSearch={onSearch}
              setSelectedId={setSelectedId}
              setDetail={setDetail}
              allocationDetail={detail}
              grants={grants}
            >
            </AllocationDetail>
        </MasterFlexWrap>
        </MasterPanelWrap>
    )
}

export default Allocation
